{
  "name": "@ns/company-turnover-declaration",
  "version": "1.0.0",
  "description": "We couldn't find a turnover figure from your company's Companies House filings — please let us know.",
  "inputs": {},
  "outcomes": {
    "complete": {
      "inputs": {
        "turnoverAmount": {
          "type": "number"
        }
      }
    }
  }
}
